import { render } from "./pengumumanLelang.vue?vue&type=template&id=6d6e9782"
import script from "./pengumumanLelang.vue?vue&type=script&lang=js"
export * from "./pengumumanLelang.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Programming\\Padmaweb\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__